<template>
  <div class="card">
    <div class="card-header">
      <div class="badge-title blue">Тональность</div>
      <date-picker v-model="date"
                   locale="ru"
                   :clearable="false"
                   format="dd.MM.yyyy"
                   model-type="yyyy-MM-dd"
                   auto-apply
                   :enable-time-picker="false"></date-picker>
    </div>
    <div class="card-body">
      <div class="point">
        <div class="title">Всего отзывов <i class="bi bi-info"></i></div>
        <div class="values" v-if="stats.negatives">
          <div class="value">{{ formatNumber(stats.negatives.total) }}</div>
          <div :class="`diff ${stats.negatives.change_direction==='up'?'green':'red'}`">
            <template v-if="stats.negatives.change_direction==='up'">+</template>
            {{ stats.negatives.change_percent }}%
          </div>
        </div>
      </div>
      <div class="point">
        <div class="title"><i class="bi bi-emoji-smile"></i> Позитивные</div>
        <div class="values" v-if="stats.positives">
          <div class="value">{{ formatNumber(stats.positives.total) }}</div>
          <div :class="`diff ${stats.positives.change_direction==='up'?'green':'red'}`">
            <template v-if="stats.positives.change_direction==='up'">+</template>
            {{ stats.positives.change_percent }}%
          </div>
        </div>
      </div>
      <div class="point">
        <div class="title"><i class="bi bi-emoji-frown"></i> Негативные</div>
        <div class="values" v-if="stats.reviews">
          <div class="value">{{ formatNumber(stats.reviews.total) }}</div>
          <div :class="`diff ${stats.reviews.change_direction==='up'?'red':'green'}`">
            <template v-if="stats.reviews.change_direction==='up'">+</template>
            {{ stats.reviews.change_percent }}%
          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import {ReviewApi} from "@/api/reviews";
import moment from "moment/moment";

export default {
  name: 'ToneStat',
  props: {},
  data() {
    return {
      date: moment().format("YYYY-MM-DD"),
      stats: {}
    }
  },
   watch: {
    date(){
      this.getData();
    }
  },
  mounted: function () {
    this.getData();

  },
  computed: {},
  methods: {
    getData(){
      ReviewApi.tone_stat(this.date).then(response => this.stats = response)
    },
    formatNumber(num) {
      if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'K';
      }
      return num.toString();
    }
  }
}

</script>
<style scoped lang="scss">
.card-body {
  display: flex;
  justify-content: space-between;
  gap: 20px;

  .point {

    width: 100%;

    &:not(:last-child) {
      border-right: 1px solid #ccc;
    }

    .title {
      padding-bottom: 5px;

      .bi-emoji-smile {
        color: rgba(52, 145, 126, 1);
        background: rgba(209, 241, 235, 1);
        border-radius: 16px;
      }

      .bi-emoji-frown {
        color: rgba(209, 0, 47, 1);
        background: rgba(255, 205, 217, 1);
        border-radius: 16px;
      }
    }

    .values {
      display: flex;
      gap: 4px;
      align-items: end;

      .value {
        color: rgba(0, 143, 248, 1);
        font-size: 24px;
        font-weight: 700;
        line-height: 24px;
      }

      .diff {
        font-size: 12px;
        line-height: 16px;

        &.green {
          color: rgba(0, 124, 101, 1)
        }

        &.red {
          color: rgba(209, 0, 47, 1);
        }
      }
    }

  }
}


</style>

